export const months = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
];

export const fundDurationYearOptions = Array.from({ length: 20 }, (_, index) => {
  const years = index + 1;
  return { label: years === 1 ? '1 year' : `${years} years`, value: String(years) };
});

export const steps = [
  { id: 'setup', name: 'Setup & Configuration' },
  { id: 'investment', name: 'Investment Details' },
  { id: 'investor', name: 'Investor Info & Requirements' },
  { id: 'docs', name: 'Documents & Disclosures' },
  { id: 'marketing', name: 'Marketing' },
  { id: 'status', name: 'Fund Status' },
];

export const fundCategorySelectOptions = [
  { label: 'Fund of Funds', value: 'FOF' },
  { label: 'Hedge Fund', value: 'HF' },
  { label: 'VC Fund', value: 'VC' },
  { label: 'Managed Account/SMAs', value: 'MAS' },
  { label: 'Lending Fund/Private Credit', value: 'LF' },
  { label: 'Real Estate Fund', value: 'REF' },
  { label: 'Private Equity Fund', value: 'PEF' },
  { label: 'Structured Product', value: 'SP' },
];

export const fundCategoryValueToLabel: Record<string, string> = {
  FOF: 'Fund of Funds',
  HF: 'Hedge Fund',
  VC: 'VC Fund',
  MAS: 'Managed Account/SMAs',
  LF: 'Lending Fund/Private Credit',
  REF: 'Real Estate Fund',
  PEF: 'Private Equity Fund',
  SP: 'Structured Product',
};

export const countrySelectOptions = [
  { label: 'USA', value: 'USA' },
  { label: 'UK', value: 'UK' },
  { label: 'Germany', value: 'Germany' },
  { label: 'Spain', value: 'Spain' },
];

export const assetTypeSelectOptions = [
  { label: 'Bonds', value: 'bonds' },
  { label: 'Commodities/Futures', value: 'commodities' },
  { label: 'Crypto', value: 'crypto' },
  { label: 'Equities', value: 'equities' },
  { label: 'Forex', value: 'forex' },
  { label: 'Real Estate', value: 'realEstate' },
  { label: 'Fully Owned Businesses', value: 'fullyOwnedBusinesses' },
  { label: 'Seed Investments', value: 'seedInvestments' },
  { label: 'Series A', value: 'seriesA' },
  { label: 'Series B+', value: 'seriesB+' },
  { label: 'Secured Loans', value: 'securedLoans' },
  { label: 'Unsecured Loans', value: 'unsecuredLoans' },
];

export const investmentDescriptionFields = [
  {
    name: 'name',
    type: 'text',
    label: 'Enter the Fund Name',
    placeholder: 'Enter the Fund Name',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    maxLength: 100,
  },
  {
    name: 'website',
    type: 'url',
    label: 'Fund Website',
    placeholder: 'Enter Fund Website',
    required: false,
    component: 'text' as const,
    column: 'right' as const,
    maxLength: 100,
  },
  {
    name: 'category',
    label: 'Fund Category',
    placeholder: 'Fund Category',
    required: true,
    options: fundCategorySelectOptions,
    component: 'select' as const,
    column: 'left' as const,
  },
  {
    name: 'legalStructure',
    type: 'text',
    label: 'Fund Legal Structure',
    placeholder: 'Fund Legal Structure',
    required: true,
    component: 'text' as const,
    column: 'right' as const,
    maxLength: 100,
  },
  {
    name: 'sizeInMillionsUsd',
    type: 'text',
    label: 'Max Fund Capacity (in million USD)',
    tooltip: 'Capacity limit when fund closes to new investment.',
    placeholder: 'Enter the Fund Size',
    required: false,
    component: 'text' as const,
    column: 'right' as const,
    onlyNumbers: true,
  },
  {
    name: 'aumInMillionsUsd',
    type: 'text',
    label: 'Current Fund AUM (in million USD)',
    tooltip:
      'Total value of assets managed by the fund, including investments and any realized gains or losses.',
    placeholder: 'Enter the Fund AUM',
    required: false,
    component: 'text' as const,
    column: 'left' as const,
    onlyNumbers: true,
  },
  {
    name: 'description',
    type: 'text',
    label: 'Enter Investment Description',
    placeholder: 'Enter Investment Description',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    multiline: true,
    rows: 4,
    maxLength: 1000,
  },
];

export const fundJurisdictionFields = [
  {
    name: 'jurisdictionCountry',
    label: 'Country',
    placeholder: 'Select Country',
    required: true,
    component: 'select' as const,
  },
  {
    name: 'jurisdictionState',
    label: 'State/Region',
    placeholder: 'Select State/Region',
    required: false,
    component: 'select' as const,
  },
];

export const keyPersonnelFields = [
  {
    name: 'Admin',
    title: 'Fund Admin',
    type: 'text',
    label: 'Name',
    placeholder: 'Enter name',
    required: false,
    component: 'text' as const,
    maxLength: 100,
  },
  {
    name: 'Auditor',
    title: 'Auditor',
    type: 'text',
    label: 'Name',
    placeholder: 'Enter name',
    required: false,
    component: 'text' as const,
    maxLength: 100,
  },
  {
    name: 'Custodian',
    title: 'Custodian',
    type: 'text',
    label: 'Name',
    placeholder: 'Enter name',
    required: false,
    component: 'text' as const,
    maxLength: 100,
  },
  {
    name: 'LegalCounsel',
    title: 'Legal Counsel',
    type: 'text',
    label: 'Name',
    placeholder: 'Enter name',
    required: false,
    component: 'text' as const,
    maxLength: 100,
  },
];

export const feesOptions = [
  { label: 'AUM', value: 'AUM' },
  { label: 'Performance', value: 'Performance' },
] as const;

export const frequencyOptions = [
  { label: 'One Time Start', value: 'OneTimeStart' },
  { label: 'One Time End', value: 'OneTimeEnd' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annual', value: 'Annually' },
  { label: 'Upon Distribution', value: 'UponDistribution' },
  { label: 'Fund Conclusion', value: 'FundConclusion' },
] as const;

export const distributionPeriodsOptions = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Semi Annual', value: 'SemiAnnual' },
  { label: 'Annual', value: 'Annual' },
  { label: 'None', value: 'None' },
] as const;

export const distributionTypeOptions = [
  { label: 'Dividends', value: 'Dividends' },
  { label: 'Interest', value: 'Interest' },
  { label: 'Capital Gains', value: 'CapitalGains' },
  { label: 'Partnership Returns', value: 'PartnershipReturns' },
] as const;

export const feeFrequencyOptions = [
  { label: 'One Time Start', value: 'OneTimeStart' },
  { label: 'One Time End', value: 'OneTimeEnd' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annual', value: 'Annually' },
  { label: 'Upon Distribution', value: 'UponDistribution' },
  { label: 'Fund Conclusion', value: 'FundConclusion' },
] as const;

export const feeTypeOptions = [
  { label: 'Management Fee', value: 'Management Fee' },
  { label: 'Performance Fee', value: 'Performance Fee' },
  { label: 'Subscription Fee', value: 'Subscription Fee' },
  { label: 'Redemption Fee', value: 'Redemption Fee' },
  { label: 'Other', value: 'Other' },
] as const;

export const strikeNAVOptions = [
  { label: 'Daily', value: 'Daily' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annually', value: 'Annually' },
] as const;

export const returnProfileLabels = [
  {
    name: 'returnPercentage',
    label: 'Return',
    placeholder: '0',
    required: false,
    component: 'text' as const,
    onlyNumbers: true,
  },
  {
    name: 'maxDrawdown',
    label: 'Max Drawdown',
    placeholder: '0',
    required: false,
    component: 'text' as const,
    onlyNumbers: true,
  },
  {
    name: 'discountPercentage',
    label: 'Distribution',
    placeholder: '0',
    required: false,
    component: 'text' as const,
    onlyNumbers: true,
  },
];

export const returnProfileNavDataLabels = [
  {
    name: 'navValue',
    label: 'NAV Value',
    placeholder: '0',
    required: true,
    component: 'text' as const,
    onlyNumbers: true,
  },
  {
    name: 'returnNavPercentage',
    label: 'Return',
    placeholder: '0',
    required: false,
    component: 'text' as const,
    onlyNumbers: true,
  },
];

const makeRangeOptions = (from: number, to: number, singular: string, plural: string) =>
  Array.from({ length: to - from + 1 }, (_, i) => {
    const n = from + i;
    const unit = n === 1 ? singular : plural;
    const label = `${n} ${unit}`;
    return { label, value: label };
  });

export const lockupOptions = [
  { label: 'None', value: 'None' },
  ...makeRangeOptions(1, 12, 'Month', 'Months'),
  ...makeRangeOptions(2, 10, 'Year', 'Years'),
];

export const gateOptions = [
  { label: 'Select', value: '' },
  { label: 'Fund', value: 'Fund' },
  { label: 'Investor', value: 'Investor' },
] as const;

export const monthsOptions = [
  { label: '0', value: '' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
] as const;

export const fundRedemptionFrequency = [
  { label: 'Daily', value: 'Daily' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annually', value: 'Annually' },
] as const;

export const fundRedemptionPriority = [
  { label: 'First in first out (FIFO)', value: 'FIFO' },
  { label: 'Last in first out (LIFO)', value: 'LIFO' },
  { label: 'Pro rata', value: 'ProRata' },
] as const;

export const redemptionTimeLabels = [
  {
    name: 'lockUpPeriod',
    label: 'Lock-up',
    placeholder: 'Select option',
    required: true,
    component: 'select' as const,
    options: lockupOptions,
    multiple: true,
  },
  {
    name: 'frequency',
    label: 'Redemption Frequency',
    placeholder: 'Select frequency',
    required: true,
    component: 'select' as const,
    options: fundRedemptionFrequency,
  },
  {
    name: 'priority',
    label: 'Redemption Priority',
    placeholder: 'Select option',
    required: true,
    component: 'select' as const,
    options: fundRedemptionPriority,
  },
  {
    name: 'noticeInDays',
    label: 'Notice',
    placeholder: 'Enter # of Days',
    required: false,
    component: 'text' as const,
    onlyNumbers: true,
  },
];

export const redemptionGatesLabels = [
  {
    name: 'max',
    label: 'Max',
    placeholder: '0',
    required: false,
    component: 'text' as const,
    onlyNumbers: true,
  },
  {
    name: 'gates',
    label: 'Gate',
    placeholder: 'Select gate',
    required: false,
    component: 'select' as const,
    options: gateOptions,
  },
  {
    name: 'months',
    label: 'Months',
    placeholder: 'Select months',
    required: false,
    component: 'select' as const,
    options: monthsOptions,
  },
];

export const fundReturnFeeType = {
  NetOfFees: 'NetOfFees',
  GrossOfFees: 'GrossOfFees',
} as const;

export const accountingTypeOptions = [
  { value: 'Fifo', label: 'FIFO' },
  { value: 'Lifo', label: 'LIFO' },
  { value: 'ProRata', label: 'Pro Rata' },
] as const;

export const countryFilterByOptions = [
  { label: 'Citizenship', value: 'Citizenship' },
  { label: 'Residency', value: 'Residency' },
  { label: 'Both', value: 'Both' },
] as const;

export const restrictedStates = [
  { label: 'Texas', value: 'Texas' },
  { label: 'California', value: 'California' },
  { label: 'Florida', value: 'Florida' },
  { label: 'Illinois', value: 'Illinois' },
  { label: 'Massachusetts', value: 'Massachusetts' },
  { label: 'New Jersey', value: 'New Jersey' },
  { label: 'New Mexico', value: 'New Mexico' },
  { label: 'New York', value: 'New York' },
  { label: 'North Carolina', value: 'North Carolina' },
  { label: 'North Dakota', value: 'North Dakota' },
  { label: 'Ohio', value: 'Ohio' },
  { label: 'Oklahoma', value: 'Oklahoma' },
  { label: 'Oregon', value: 'Oregon' },
  { label: 'Pennsylvania', value: 'Pennsylvania' },
  { label: 'Rhode Island', value: 'Rhode Island' },
  { label: 'South Carolina', value: 'South Carolina' },
];

export const fundStatusOptions = [
  { label: 'Open', value: 'Open' },
  { label: 'Closed', value: 'Closed' },
  { label: 'Pre-Launch', value: 'PreLaunch' },
  { label: 'Private', value: 'Private' },
] as const;

export const transferabilityOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'Other Investors Only', value: 'OtherInvestorsOnly' },
  { label: 'By Request', value: 'ByRequest' },
] as const;

export const shareClassOptions = [
  { label: 'Preferred Shares', value: 'PreferredShares' },
  { label: 'Ordinary Shares', value: 'OrdinaryShares' },
  { label: 'Class A Shares', value: 'ClassAShares' },
  { label: 'Class B Shares', value: 'ClassBShares' },
  { label: 'Class C Shares', value: 'ClassCShares' },
  { label: 'Limited Partnership Units', value: 'LimitedPartnershipUnits' },
  { label: 'General Partner Units', value: 'GeneralPartnerUnits' },
] as const;

export const shareholderTypeOptions = [
  { label: 'Individual', value: 'Individual' },
  { label: 'Entity', value: 'Entity' },
] as const;

export const bankDetailsFields = [
  {
    name: 'name',
    type: 'text',
    label: 'Bank Name',
    placeholder: 'Enter the Bank Name',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    maxLength: 100,
    errorId: 'bankDetails',
  },
  {
    name: 'address',
    label: 'Bank Address',
    placeholder: 'Enter the Address',
    required: true,
    component: 'text' as const,
    column: 'right' as const,
    maxLength: 100,
    errorId: 'bankDetailsAddress',
  },
  {
    name: 'city',
    type: 'text',
    label: 'Bank City',
    placeholder: 'Enter the City',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    maxLength: 100,
    errorId: 'bankDetailsCity',
  },
  {
    name: 'state',
    type: 'text',
    label: 'State/Province/Region',
    placeholder: 'Enter the State',
    required: true,
    component: 'select' as const,
    column: 'left' as const,
    errorId: 'bankDetailsState',
  },
  {
    name: 'country',
    type: 'text',
    label: 'Bank Country',
    placeholder: 'Select the Bank Country',
    required: true,
    component: 'select' as const,
    column: 'right' as const,
    options: [],
    errorId: 'bankDetailsCountry',
  },
  {
    name: 'zipCode',
    type: 'text',
    label: 'ZIP code',
    placeholder: 'Enter ZIP Code',
    required: true,
    component: 'text' as const,
    column: 'right' as const,
    maxLength: 20,
    onlyNumbers: true,
    errorId: 'bankDetailsZipCode',
  },
];

export const beneficiaryDetailsFields = [
  {
    name: 'accountNumber',
    type: 'text',
    label: 'Account Number',
    placeholder: 'Enter the Account Number',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    maxLength: 50,
    onlyNumbers: true,
    errorId: 'bankDetailsAccountNumber',
  },
  {
    name: 'bankIdentifierCode',
    type: 'text',
    label: 'SWIFT/BIC Code',
    placeholder: 'Enter the SWIFT/BIC Code',
    required: true,
    component: 'text' as const,
    column: 'right' as const,
    maxLength: 20,
    errorId: 'beneficiaryDetailsBankIdentifierCode',
  },
  {
    name: 'ABARouting',
    type: 'text',
    label: 'ABA routing',
    placeholder: 'Enter the ABA routing',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    maxLength: 20,
    onlyNumbers: true,
    errorId: 'beneficiaryDetailsABARouting',
  },
  {
    name: 'name',
    type: 'text',
    label: 'Beneficiary Name',
    placeholder: 'Enter the Beneficiary Name',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    maxLength: 100,
    errorId: 'beneficiaryDetails',
  },
  {
    name: 'address',
    type: 'text',
    label: 'Beneficiary Address',
    placeholder: 'Enter the Beneficiary Address',
    required: true,
    component: 'text' as const,
    column: 'right' as const,
    maxLength: 100,
    errorId: 'beneficiaryDetailsAddress',
  },

  {
    name: 'city',
    type: 'text',
    label: 'City',
    placeholder: 'Enter the City',
    required: true,
    component: 'text' as const,
    column: 'left' as const,
    maxLength: 100,
    errorId: 'beneficiaryDetailsCity',
  },
  {
    name: 'country',
    type: 'text',
    label: 'Country',
    placeholder: 'Select the Country',
    required: true,
    component: 'select' as const,
    column: 'right' as const,
    options: [],
    errorId: 'beneficiaryDetailsCountry',
  },
  {
    name: 'state',
    type: 'text',
    label: 'State/Province/Region',
    placeholder: 'Select the State',
    required: true,
    component: 'select' as const,
    column: 'left' as const,
    options: [],
    errorId: 'beneficiaryDetailsState',
  },
  {
    name: 'zipCode',
    type: 'text',
    label: 'ZIP code',
    placeholder: 'Enter ZIP Code',
    required: true,
    component: 'text' as const,
    column: 'right' as const,
    maxLength: 100,
    onlyNumbers: true,
    errorId: 'beneficiaryDetailsZipCode',
  },
  {
    name: 'notes',
    type: 'text',
    label: 'Notes',
    placeholder: 'Enter Notes',
    required: false,
    component: 'text' as const,
    column: 'left' as const,
    multiline: true,
    rows: 4,
    maxLength: 5000,
  },
];

export const investmentAvailabilityTooltip = [
  {
    label: 'Open',
    description: 'Visible to the public. Open to investing.',
  },
  {
    label: 'Closed',
    description:
      'Visible to the public. Fully invested so investment is not possible at this time.',
  },
  {
    label: 'Pre-Launch',
    description:
      'Visible to the public. Public cannot invest but they can register their interest.',
  },
  {
    label: 'Private',
    description: 'Not visible to the public. Not open to investing.',
  },
];

export const transferabilityTooltip =
  'This property can be changed later from the Fund Management page.';

export { SANCTIONED_COUNTRIES as notAllowedCountries } from './constants/sanctioned-countries';
export { setupFund } from './section-copy';

export const subscriptionMethodOptions = [
  { value: 'Crypto', label: 'Crypto' },
  { value: 'Wire', label: 'Wire' },
  { value: 'Both', label: 'Both' },
] as const;

export const feesOption = [
  { value: fundReturnFeeType.NetOfFees, label: 'Net of fees' },
  { value: fundReturnFeeType.GrossOfFees, label: 'Gross of fees' },
];

/** Backend enum → frontend navData value */
export const pdsFromBackend: Record<string, 'file' | 'form' | 'merge'> = {
  UploadedFile: 'file',
  ThisForm: 'form',
  Merge: 'merge',
};

/** Frontend navData value → backend enum */
export const pdsToBackend: Record<string, string> = {
  file: 'UploadedFile',
  form: 'ThisForm',
  merge: 'Merge',
};
